// What scrolls the page depends on the width.
//
// Phones: the window, with the teacher a drawer over it. 900 px and up (Matt's
// iPad in landscape): the window is locked one screen tall and the page
// scrolls in its own pane beside the teacher's column, so the chat box never
// leaves the screen (Matt, 2026-10-12). Anything that sends the page back to
// the top has to move both.
export function scrollPageToTop () {
  window.scrollTo({ top: 0 });
  document.querySelector('.enjoy-cooking__content')?.scrollTo({ top: 0 });
}
